@if (isBrowser) {
  <svg [attr.viewBox]="viewBox" class="nbhd-map" role="img" [attr.aria-label]="ariaLabel()">
    @for (p of points(); track p.neighborhoodId) {
      <circle
        [attr.cx]="p.x"
        [attr.cy]="p.y"
        [attr.r]="p.r"
        [attr.fill]="color"
        [attr.fill-opacity]="p.opacity"
        [attr.stroke]="color"
        stroke-opacity="0.9"
      >
        <title>{{ p.name }} — {{ p.label }}</title>
      </circle>
      <text [attr.x]="p.x" [attr.y]="p.y + p.r + 11" text-anchor="middle">{{ p.name }}</text>
    }
  </svg>
} @else {
  <div class="chart ssr-placeholder" [style.height.px]="height()"></div>
}
